import { push } from "connected-react-router";

const csvScanner = () => {
  return push(`/csv/scanner`);
};

export const gotoCsvScanner = {
  csvScanner: csvScanner,
};
